import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=7258a4c1"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports